import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import Table from "../../../Components/Table/Table";
import { FilterButton, SearchFilter } from "../../../Components/Search/Search";
import Pagination from "../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { URL } from "../../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { TableActions } from "../../../Components/Misc/ActionsModVersion";
import "./style.css";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { FiCheck, FiEdit2, FiEye, FiTrash, FiX } from "react-icons/fi";
import { ApproveDeclineCostClasses, DisableCostClass, GetCostClasses, setEditMode, viewCostClass } from "../../../../../utils/redux/Finance/CostCenterSlice/CostCenterSlice";
import { FormSelectAlt } from "../../../Components/Forms/InputTemplate";
import { getStandardStatus } from "../usefulFunctions";

export function getStatusText(code) {
  // console.log({code})
  let status = getStandardStatus(code);
  return <p className={`${code === 0? 'bg-[#CBFFAE80] text-[#067306]' : code === 7? 'bg-[#FCEBEC] text-[#9E0038]' : 'bg-gray-100 text-gray-600'} text-center text-sm w-[90px] min-w-max rounded-xl p-1` }>
    {status}
  </p>
} 

function CostCenterClass() {
  // table state
  const tableData = useSelector((state) => state?.costCenter?.CostCenterClass);

  // Filter states
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  /**Data Fetching */
  useEffect(() => {
    let fmtStatus = parseInt(status);
    dispatch(GetCostClasses({ pageSize, pageNumber, search, status: fmtStatus }));
  }, [dispatch, pageNumber, pageSize, search, status]);

  // Action Button at the top of screen
  const actionButton = (
    <>
      <CTAButtons
        onClick={() => {
          navigate(`../${URL.CostCenterClassSetup}`);
        }}
      >
        Create Class
      </CTAButtons>
    </>
  );

  // Table Headers format:
  const headerSetter = () => {
    return [
      { title: "Class Name", key: "name" },
      { title: "Short Code", key: "code" },
      { title: "Retirement Days", key: "retirementDays" },
      { title: "Approval Status", key: "status" },
      { title: "Actions", key: null },
    ];
  };
  let currentHeaders = headerSetter();

  // Format for "More Options" buttons:
  let mockRowOptions = [
    {
      name: "View",
      icon: <FiEye />,
      action: (rowData) => {
        console.log({ classID: rowData.id });
      },
    },
    {
      name: "Edit",
      icon: <FiEdit2 color="#946300" />,
      action: (rowData) => {
        dispatch(setEditMode(true));
        dispatch(viewCostClass(rowData));
        navigate(`../${URL.CostCenterClassSetup}`);
      },
    },
    { name: "Disable", icon: <FiTrash color="#E61B00" />, action: (rowData) => { 
      // console.log({rowData})
      dispatch(DisableCostClass({ id: rowData.id }))
      .then(()=> dispatch(GetCostClasses()));
    }},
    { name: "Approve", icon: <FiCheck color="#E61B00" />, action: (rowData) => {
      dispatch(ApproveDeclineCostClasses({
        "id": rowData.id,
        "costClassName": rowData.name,
        "status": 0
      }))
      .then(()=> dispatch(GetCostClasses()));
    } },
    { name: "Decline", icon: <FiX color="#E61B00" />, action: (rowData) => {
      dispatch(ApproveDeclineCostClasses({
        "id": rowData.id,
        "costClassName": rowData.name,
        "status": 7
      }))
      .then(()=> dispatch(GetCostClasses()));
    } },
  ];

  
  // console.log({status: parseInt(status)});

  return (
    <RouteLayout title={"Finance"}>
      <PageStyle
        title={"Class List"}
        hasBack={true}
        isMain={true}
        action={[actionButton]}
      >
        <div className={DashboardStyle.dashboard_filter}>
          <SearchFilter text={setSearch} />
          <div className="text-green-800">
            <p>Approval Status</p>
            <select onChange={({target})=> setStatus(target.value)} defaultValue={status} className="rounded border border-[#D9E9DA] h-[40px] focus:outline-green-800">
              <option value={0}>Approved</option>
              <option value={7}>Declined</option>
              <option value={1}>Pending</option>
            </select>
          </div>
          <FilterButton onSubmit={()=> {}} onClick={() => dispatch(GetCostClasses({ pageSize, pageNumber, search, status }))} name="" />
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                {currentHeaders.map((header, i) => (
                  <th
                    className={`!text-[#29382A] ${
                      header.title === "Actions" && "flex justify-end !pr-6"
                    }`}
                    key={i}
                  >
                    {header.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={tableData?.pageItems}
                keys={currentHeaders.map((header) => header.key)}
                selectable={false}
                rowOptions={mockRowOptions}
              />
            </tbody>
          </Table>
        </div>
        <Pagination
          last_page={tableData?.totalPages}
          present_page={tableData?.currentPage || pageNumber}
          totalRows={tableData?.pageItems?.length < pageSize? tableData.pageItems.length : (tableData?.pageSize * tableData?.totalNumberOfPages) || 0}
          pageSize={tableData?.pageItems?.length < pageSize?  tableData.pageItems.length : tableData?.pageSize || 0}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        />
      </PageStyle>
    </RouteLayout>
  );
}

export default CostCenterClass;

function RequestTable({
  data,
  keys,
  selectable,
  HandleSelectedItems,
  selectedItems,
  rowOptions,
}) {
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log({data, keys})
  return (
    <>
      {data?.map((item) => (
        <tr key={item.id}>
          {selectable && (
            <td>
              <input
                type="checkbox"
                checked={selectedItems.includes(item.id)}
                onChange={(e) => HandleSelectedItems(item.id, e.target.checked)}
                style={{ height: "20px", width: "20px" }}
              />
            </td>
          )}
          {keys
            .filter((key) => { return key})
            .map((key, i) => (
              <td key={i}>{key !== 'status'? item[key] : getStatusText(item[key])}</td>
            ))}
          <td>
            <div className={`flex justify-end bg-transparent`}>
              <TableActions children={rowOptions} rowData={item} url={null}>
                {rowOptions}
              </TableActions>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}
